import React, { useEffect, useRef, useState } from 'react';
import { useParams, useOutletContext } from 'react-router-dom'; 
import Message from './Message';
import ChatInput from './ChatInput';
import { FaSearch, FaEllipsisV,FaUserCircle } from "react-icons/fa";
import api from '../utils/api';
import FullScreenLoader from '../components/Loader';

const ChatWindow = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  
  const scrollRef = useRef(null);

  const [messages,setMessages] = useState([]);
  const [chatexpireWindow,setChatexpireWindow] = useState('close');
  const [profileName,setprofileName] = useState('');

  useEffect(() => {
    if(id){
      fetchMessages(id);
    }
  }, [id]);

  const scrollToLatest = () =>{
    if (scrollRef.current) {
        scrollRef.current.scrollTo({
          top: scrollRef.current.scrollHeight,
          behavior: 'smooth', 
        });
    }
  }

  const fetchMessages = async(id) =>{
    try {
      const res = await api.get(`/messages/${id}`);
      if(res?.status == 200){
        setMessages(res.data?.messages);
        setChatexpireWindow(res.data?.chat_window);
        setprofileName(res.data?.profile_name);
        scrollToLatest();
      }
    } catch (err) {
      console.log(err);
    } finally{
      setLoading(false);
    }
  }


  const onSendMessage = async(text) => {
    try {
      if (text.trim() !== "") {
        setLoading(true);
        let body = {
          wa_id:id,
          message:text
        }

        const res = await api.post(`/send-message`,body);
        console.log(res?.status,res);
        if(res?.status == 200){
          fetchMessages(id);
          scrollToLatest();
        }
      }
    } catch (error) {
      
    } finally{
      setLoading(false);
    }
    
  };


  return (
    <div className="chat-window">
      {loading && <FullScreenLoader />}

      <div className="header" style={{ borderLeft: '1px solid #e9edef' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <FaUserCircle fontSize={35} />
          <div style={{ marginLeft: '15px' }}>
            <h4 style={{ margin: 0, fontSize: '16px' }}>{profileName}</h4>
            <h4 style={{ margin: 0, fontSize: '14px' }}>{id}</h4>
          </div>
        </div>
      </div>

      <div className="chat-body" ref={scrollRef} style={{ overflowY: 'auto' }}>
        {messages.map((msg) => (
          <Message 
            key={msg.id}
            text={msg.body}
            time={msg.timestamp}
            media_type={msg.media_type}
            media_url={msg.media_url}
            status={msg.status}
            error_msg={msg.error_msg}
            isOutgoing={msg.sender !== 'user'}
          />
        ))}
      </div>
      
        {(chatexpireWindow == 'close') ? (
          <div className="closed-window-notice">
              The 24-hour conversation window has closed. Wait for the user to message you to reopen the chat.
          </div>
        ) : (
          <ChatInput onSendMessage={onSendMessage} />
        )} 
    </div>
  );
};

export default ChatWindow;